import React from 'react';

import { YatPickerDropdown } from '@pkg/components/YatPickerDropdown';
import { useAppSelector } from '@pkg/hooks';

import { useEmojisStore } from '@app/store/zustand/emojis/useEmojisStore';

import { Wrapper } from './styles';

export const YatPicker = () => {
    const userEmojis = useEmojisStore((state) => state.emojis);
    const hasYats = !!userEmojis.length;
    const primaryYat = useAppSelector((state) => state.user?.primaryYat);

    return (
        <Wrapper>
            <YatPickerDropdown primaryYat={primaryYat} hasYats={hasYats} />
        </Wrapper>
    );
};
